import { Component, computed, input, signal } from "@angular/core";
import { NgxPaginationModule } from "ngx-pagination";
import { NewsCardComponent } from "../../../shared/news-card/news-card.component";
import { NewsroomArticle } from "../../newsroom-article";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.scss"],
  imports: [NewsCardComponent, NgxPaginationModule],
})
export class PaginationComponent {
  public readonly totalItems = input(0);
  public readonly itemsPerPage = input(4);
  public readonly allArticles = input<NewsroomArticle[]>([]);
  public readonly articlesPerPage = input(4);
  public readonly currentPage = signal(1);

  public readonly cardsConfigTop = computed(() => {
    const startIndex = (this.currentPage() - 1) * this.itemsPerPage();
    const endIndex = startIndex + this.itemsPerPage();
    return this.allArticles().slice(startIndex, endIndex);
  });
}
